import React from 'react'
import { useDispatch } from 'react-redux'
import styles from './Species.module.css'

import { deleteSpecies } from '../../../actions/actions'

const Species = ({ species, setCurrentId }) => {

    const dispatch = useDispatch()

    return (
        <div className={styles.species}>
            <div>
                <img src={species.imageUrl} alt={species.commonName} className={styles.image}/>
            </div>
            <div className={styles.name}>
                <p>{species.commonName} | <span className={styles.sciName}>{species.scientificName} </span></p>
            </div>
            <div className={styles.buttons}>
                <button onClick={() => setCurrentId(species._id)}><i className="far fa-edit"></i></button>
                <button onClick={() => dispatch(deleteSpecies(species._id))}><i className="far fa-trash-alt"></i></button>
            </div>
        </div>
    )
}

export default Species
